import { Route, Routes } from "react-router-dom";
import CompareWithOdoo from "./CompareWithOdoo";

const ALCWarehouse = () => (
  <Routes>
    <Route>
      <Route path=":name" element={<CompareWithOdoo />} />
    </Route>
  </Routes>
);

export default ALCWarehouse;
